import { OPERATIONS_HERO } from '@/data/operations';
import { ServiceLineHero } from '../service/ServiceLineHero';

export const OperationsHero = () => (
  <ServiceLineHero
    content={OPERATIONS_HERO}
    accent="#FFB800"
    accentDark="#9C7400"
    accentSoft="#FFF3CC"
    testidPrefix="operations"
  />
);
